import { FormattedMessage } from 'react-intl';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import TitleInfoPopover from './TitleInfoPopover';

interface HeaderProps {
    isStale?: boolean;
    notAvailable?: boolean;
    isLoading?: boolean;
    staleTooltip?: string;
}

const Header = ({ isStale, notAvailable, isLoading, staleTooltip }: HeaderProps) => (
    <div>
        <h6 className="text-uppercase text-color-dark">
            <FormattedMessage id="intl-msg:tyres.header.title" />
            {!notAvailable && !isLoading && <TitleInfoPopover />}
            {isStale && !notAvailable && staleTooltip && (
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 100, hide: 0 }}
                    overlay={<Tooltip>{staleTooltip}</Tooltip>}
                >
                    <span className="label label-default label-condensed margin-left-5">
                        <FormattedMessage id="intl-msg:tyres.header.notSynced" />
                    </span>
                </OverlayTrigger>
            )}
        </h6>
        {isLoading ? (
            <div className="margin-top-10 margin-bottom-10">
                <ContentLoader height={16} width="60%" />
            </div>
        ) : (
            <p className="text-size-14 margin-top-0">
                {notAvailable ? (
                    <FormattedMessage id="intl-msg:tyres.header.notAvailable" />
                ) : (
                    <FormattedMessage id="intl-msg:tyres.header.subtitle" />
                )}
            </p>
        )}
    </div>
);

export default Header;
